// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"14772887","182":"390b1263","304":"b0752ab4","344":"93c9cd8d","430":"5ab17786","473":"a2784349","490":"887fd3c9","566":"d7a57676","838":"8811f70d"}[chunkId] + ".chunk.js";
};